<template>
  <RouteAlive ref="routeAlive"
              :current="current"
              :include="includeRoute"
              @destroyed="handleDestroyed"
              @removed="handleRemoved"></RouteAlive>
</template>

<script>
import RouteAlive from './RouteAlive'
import Fragment from '../../../mixins/fragment'
import {mapState, mapMutations} from 'vuex'
export default {
  name: 'MainRouteKeepAlive',
  mixins: [Fragment],
  components: {
    RouteAlive
  },
  computed: {
    ...mapState({
      current: state => state.layout.main.tab.current,
      tabOptions: state => state.layout.main.tab.options
    }),
    includeRoute () {
      if (this.tabOptions) {
        return this.tabOptions.map(option => option.name)
      }
    }
  },
  methods: {
    ...mapMutations(['removeMainTab']),
    refreshCurrent () {
      let routeAlive = this.$refs.routeAlive
      if (routeAlive) {
        routeAlive.refreshCurrent()
      }
    },
    handleDestroyed (key) {
      this.removeMainTab(key)
      this.$nextTick(() => {
        this.handleRemoved([key])
      })
    },
    handleRemoved (keys) {
      if (this.tabOptions) {
        if (keys && keys.length) {
          keys.forEach(key => {
            let matchId = key.split(':')[0]
            if (!this.tabOptions.includes(matchId)) {
              this.deleteFragment(matchId)
            }
          })
        }
      }
    }
  }
}
</script>
